<template>
    <el-dialog
            :close-on-click-modal="false"
            :before-close="resetForm"
            :visible.sync="visible">

        <div slot="title">
            <z-title :title="(state==0?'新增':'编辑')+'角色'"></z-title>
        </div>
        <el-form :model="dataForm" :rules="rules" ref="ruleForm" class="rulefrom">
            <el-form-item label="名 称" prop="roleName" label-width="60px">
                <el-input placeholder="请输入角色名称" v-model="dataForm.roleName" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="状 态"  prop="roleState" label-width="60px">
                <el-radio-group v-model="dataForm.roleState">
                    <el-radio label="0">停用</el-radio>
                    <el-radio label="1">开启</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="备 注" prop="remark" label-width="60px">
                <el-input type="textarea" rows="6" show-word-limit v-model="dataForm.remark" resize="none"
                          maxlength="512"></el-input>
            </el-form-item>
            <!--<el-form-item label="用户角色" prop="roleId" label-width="120px">-->
                <!--<el-select v-model="dataForm.roleId" @visible-change="getRoleList" placeholder="请选择角色"-->
                           <!--style="width: 100%">-->
                    <!--<el-option-->
                            <!--v-for="item in roleList"-->
                            <!--:key="item.roleId"-->
                            <!--:label="item.roleName"-->
                            <!--:value="item.roleId">-->
                    <!--</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="所属店铺" prop="storeIds" :show-message="false"  label-width="120px">-->
                <!--<el-select v-model="dataForm.storeIds" @visible-change="showAllStoreList" multiple-->
                           <!--placeholder="请选择需要绑定的店铺" style="width: 100%">-->
                    <!--<el-option-->
                            <!--v-for="item in allStoreList"-->
                            <!--:key="item.storeId"-->
                            <!--:label="item.storeName"-->
                            <!--:value="item.storeId">-->
                    <!--</el-option>-->
                <!--</el-select>-->
            <!--</el-form-item>-->
            <el-form-item class="mt-10 flex-n fje">
                <el-button type="primary" @click="submitForm('ruleForm')">保 存</el-button>
                <el-button @click="resetForm">取 消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>

</template>

<script>

    import ZTitle from "../../../components/ZTitle";

    export default {
        components: {ZTitle},
        name: "edit-role",
        props:{
            visible:Boolean,
            state:String|Number,
            id:String
        },
        data(){
            return{
                dataForm: {
                    roleName:'',
                    roleState:'1',
                    remark:''
                },
                editstate: '新增',

                roleList: [],
                dataList: [],

                rules: {
                    roleName: [
                        {max: 8, message: '最大允许输入8个字符', trigger: 'change'},
                        {required: true, message: '不能为空', trigger: 'blur'}
                    ],


                },
            }
        },
        watch:{
          visible(newval,oldval){
              if(newval){
                  if(this.state==1){
                      this.getData(this.id)
                  }
              }
          }
        },
        methods:{
            //编辑
            getData(id) {

                this.$axios.get('/role/findById/'+id).then(res=>{
                    this.dataForm=res.data;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            resetForm(){
                this.$refs.ruleForm.resetFields();
                this.$emit('update:visible',false);
                this.$emit('refreshList');
            },
            //添加提交
            addSubmit(){
                let {roleName,roleState,remark}=this.dataForm;
                this.$axios.post('/role/save', {
                    "roleName": roleName,
                    "roleState": roleState,
                    "remark": remark,
                    "storeId": this.$root.getStorage('storeId')
                }).then(res => {
                    this.$message.success('新增角色成功！');
                    this.resetForm();
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            //编辑提交
            editSubmit(){
                let {roleName,roleState,remark}=this.dataForm;
                this.$axios.post('/role/update',{
                    "id": this.id,
                    "roleName": roleName,
                    "roleState": roleState,
                    "remark": remark,
                    "storeId": this.$root.getStorage('storeId')
                }).then(res=>{
                    this.$message.success('编辑角色成功！')
                    this.resetForm();
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            //验证表单
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.state == 0) {
                            this.addSubmit();
                        } else {
                            this.editSubmit();
                        }
                    } else {
                        this.$message.error('表单填写有误');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>